import GenericAjaxService from './GenericAjaxService';
import {privateAPI} from './api';
export default class SpsCallibration extends GenericAjaxService {
  static validateSPSLogin(){
    return super.getAPI(privateAPI, `spsCallibration/accessSPSCal`);
  }
}